import { HeroSection } from './components/HeroSection/HeroSection';
import { NavBar } from './components/NavBar/NavBar';
import styles from './HomePage.module.css';

export const HomePage = () => {
  return (
    <div>
      <NavBar />
      <HeroSection />
    </div>
  );
};